import { useBlogPost } from '@/hooks/useBlogPost'
import React from 'react'
import { useLocation, useParams } from 'react-router'
import moment from 'moment'
import { ProgressSpinner } from '../Common/ProgressSpinner'

export const Post = () => {
  const { blogId } = useParams()
  const { post, isLoading, isError } = useBlogPost(blogId)
  const { state } = useLocation()

  const blogPost = post ? post : state

  if (isLoading && !blogPost)
    return (
      <div className="flex justify-center items-center h-96">
        <ProgressSpinner />
      </div>
    )

  return (
    <div className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl">
          {/* Title */}
          <h2 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl md:text-4xl">
            {blogPost?.title}
          </h2>

          {/* Header Image */}
          <img
            src={blogPost?.headerImg}
            alt={blogPost?.title}
            className="w-full max-h-80 object-cover rounded-lg my-4"
          />

          {/* Date and Author */}
          <div className="text-sm text-neutral-500">
            {moment(blogPost?.created).format('LLL')}
          </div>
          <p className="my-4 text-base leading-8">
            <span className="text-primary font-semibold">Author:</span>{' '}
            {blogPost?.author}
          </p>

          {/* Blog Body */}
          <div>
            {blogPost?.body
              .split('\n')
              .map((bodyPart: string, index: number) => (
                <React.Fragment key={index}>
                  <p className="mt-2 text-base sm:text-lg leading-7 sm:leading-8 text-justify">
                    {bodyPart}
                  </p>
                  <br />
                </React.Fragment>
              ))}
          </div>
        </div>
      </div>

      {/* Error Handling */}
      {isError && (
        <div className="mt-8 text-center text-red-500">
          Error loading blog: {isError?.message}
        </div>
      )}
    </div>
  )
}
